<template>
    <!-- 详情&编辑 -->
    <AlarmSeting :title="triggerInfo && triggerInfo.name" :rangeArray="rangeArray" :isShow.sync="isShow"
        :detailObj="triggerInfo" ref="alarmSet" />
</template>

<script>
import AlarmSeting from '@/pages/business/components/dialog/AlarmSeting.vue';
import { alarmTriggerDetail } from '@/api/modules/alarm.js';
import mixinRange from '@/utils/getRange.js';
export default {
    props: ['id'],
    mixins: [mixinRange],
    components: {
        AlarmSeting
    },
    data() {
        return {
            title: '',
            isShow: false,
            triggerInfo: null,
            rangeArray: []
        };
    },
    watch: {
        id() {
            if (this.id) {
                this.isShow = true;
                this.initTriggerDetail();
            }
        },
        isShow() {
            if (!this.isShow) {
                this.$nextTick(() => {
                    this.$refs['alarmSet'].resetFn();
                });
            }
        }
    },
    mounted() {
        this.rangeArray = this.getCustomerList({
            type: 1,
            tab: 1
        }).then(({ result }) => {
            this.rangeArray = result;
        })
    },
    methods: {
        initTriggerDetail() {
            alarmTriggerDetail(this.id).then(({ result }) => {
                this.triggerInfo = result;
                this.$emit('update:id', null);
            });
        }
    }
};
</script>
